export default __webpack_public_path__ + "static/media/loader.68d897f4.png";